// extracted by css-extract-rspack-plugin
export default {"cls1":"Attachment-cls1_yDq","cls2":"Attachment-cls2_K0d Attachment-cls1_yDq"};